import jsPDF from 'jspdf'
import { PrintLogo } from '../img'
import moment from 'moment'

const generatePDF = (doc) => {
  const d = new jsPDF();
  d.setFont("helvetica");
  d.setFontSize(10);
  d.addImage(PrintLogo, "PNG", 1, 4, 40, 40);
  d.text(5, 50, 'Folio: '+ doc.folio);
  d.text(5, 58, 'Asunto: '+ doc.subject);
  d.text(5, 66, 'Fecha: '+ moment(doc.date).format('LL'));
  d.text(5, 74, 'Emisor: '+ doc.from);
  d.text(5, 82, 'Receptor: '+ doc.to);
  let lastLine = 90

    //si trae con copia los imprime
    if(doc.cc.length > 0){

      let users = 'Con copia: ';
      doc.cc.forEach( user =>

        {
          users += (user.external === true)?  user.ext_job_title + ' '+ user.ext_name + ', ' : user.to.name.title + ' '+ user.to.name.full + ', '
        }

      )

      var fixedUsers = d.splitTextToSize(users, 180);
      d.text(5, lastLine, fixedUsers)
    }

  //si vienen usuarios con copia agrego espacio(5pts por c/u) por cada uno de ellos
  d.text(5, (doc.cc.length > 0)? lastLine += (doc.cc.length * 5) : lastLine, 'Contenido: ');

    const containerBody = JSON.parse(doc.content)

    let blocks = null
    if((containerBody !== null) && (typeof containerBody !== 'undefined')){
      if(typeof containerBody.document.nodes !== 'undefined'){
        blocks = containerBody.document.nodes
        if (typeof blocks === 'object'){
          blocks.forEach( block =>

            //imprime bloques de texto plano del contenido del oficio
            {
              if(typeof block !== 'undefined'){
                if(typeof block.nodes[0] !== 'undefined'){
                  if(typeof block.nodes[0].leaves !== 'undefined'){
                    if(typeof block.nodes[0].leaves[0].text !== 'undefined'){
                      var text = d.splitTextToSize(block.nodes[0].leaves[0].text, 200);
                      lastLine += 8
                      d.text(5, lastLine, text)
                      lastLine += 2
                    }
                  }
                }
              }
            }
          )
        }
      }
    }

  d.save(doc.folio+".pdf");
}

export default generatePDF;



// WEBPACK FOOTER //
// ./src/functions/generatePDF.js